/**
* ユーザー管理関連
*/

import axios from '@/plugins/axios';
import cf from '@/mixins/commonFunctions';
import login from './login';
import counseling from './counseling';

const actions = {
  setUserData({ commit }, data) {
    commit('setUserData', data);
  },


  /** DBからユーザー情報を取得しstate更新 */
  update({ commit, state }) {
    const ls = cf.getLocalStorage('wtt');
    // localStorageが存在しない場合はスルー
    if (!ls) return Promise.resolve();

    // TODO: user情報をDBから取得してアップデート

    if (state.login.isLogin && ls.jwt) {
      // Promise を return して呼び出し側が GET 完了を待てるようにする
      // （再取得後の再バインドを順序保証したい画面があるため）
      return axios({
        method: 'GET',
        url: '/v1/user/get/detail',
        params: {
          id: state.id,
          isOperatorMessage: 1,
          isCounselorMessage: 1,
        },
      })
        .then((response) => {
          const user = response.data.data;
          commit('update', user);
        })
        .catch((error) => {
          if (error.response) console.log(error.response.data);
          else console.log(error);
        });
    }
    return Promise.resolve();
  },
};

const mutations = {
  setUserData(state, data) {
    const keys = Object.keys(data);
    keys.some((key) => {
      // passwordはstoreで保持しない
      if (key !== 'password') {
        state[key] = data[key];
      }
      return false;
    });
  },

  update(state, user) {
    const userKeys = Object.keys(user);
    const stateKeys = Object.keys(state);
    // 取得したuserの値をまわして
    userKeys.some((key) => {
      // キーが存在するstateを更新
      if (stateKeys.includes(key)) {
        // console.log(key);
        state[key] = user[key];
      }
      return false;
    });
  },
};

const state = {
  id: '',
  username: '',
};


export default {
  namespaced: true,
  actions,
  mutations,
  state,
  modules: {
    login,
    counseling,
  },
};
